<div class="container col-md-6 col-12 mt-5">
  <form
    class="row g-3 border border-1 rounded-2 p-3"
    (submit)="onSubmit($event)"
  >
    <h2 class="text-center">Register</h2>

    <div class="col-md-12">
      <input
        type="email"
        class="form-control"
        placeholder="Email"
        (input)="email.set($any($event.target).value)"
        required
      />
    </div>

    <div class="col-md-12">
      <input
        type="password"
        class="form-control"
        placeholder="Password"
        (input)="password.set($any($event.target).value)"
        required
      />
    </div>

    <div class="col-12 d-grid">
      <button class="btn btn-primary" [disabled]="auth.loading()">
        @if (auth.loading()) {
            Registering...
        } @else {
            Sign Up
        }
      </button>
    </div>

    @if (auth.error()) {
      <div class="text-danger text-center">
        {{ auth.error() }}
      </div>
    }

    <span>
      Already registered?
      <a routerLink="/login">Sign In</a> here.
    </span>
  </form>
</div>
